import Input from "../../core/Input.tsx";
import { IconMail } from "@tabler/icons-react";
import { ErrorMessage } from "@hookform/error-message";
import {
  TEXT_EMAIL_LENGTH,
  TEXT_EMAIL_REQUIRED,
  TEXT_EMAIL_VALID,
} from "../../../const/text.ts";
import { isValidEmail } from "../../../types/BaseTypes.ts";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";

const EmailInput = ({
  requiredText = TEXT_EMAIL_REQUIRED,
}: {
  requiredText?: string;
}) => {
  const {
    register,
    formState: { errors, touchedFields },
  } = useFormContext();
  useEffect(() => {}, [errors]);
  return (
    <Input
      input="input"
      label={"E-Mail"}
      validatorHint={<ErrorMessage errors={errors} name="email" />}
      icon={<IconMail stroke={2} />}
      isTouched={!!touchedFields.email}
      isError={!!errors.email}
    >
      <input
        type="email"
        inputMode="email"
        autoComplete="email"
        placeholder="E-Mail"
        minLength={3}
        maxLength={254}
        title="Invalid e-mail"
        {...register("email", {
          required: requiredText,
          validate: {
            length: (v) => v.length > 3 || TEXT_EMAIL_LENGTH,
            format: (v) => isValidEmail(v) || TEXT_EMAIL_VALID,
          },
        })}
      />
    </Input>
  );
};
export default EmailInput;
